<template>
  <v-layout row wrap class="px-0">
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="messages"
        :search="search"
        item-key="messageid" :sort-by="sortBy"
        :footer-props="footerProps" no-data-text="пусто" no-results-text="ничего не найдено"
        :items-per-page.sync="itemsPerPage"
        dense flat
      >
        <template v-slot:item.cts="{ item }">
          {{ dateFormat(item.cts) }}
        </template>

        <template v-slot:item.transport="{ item }">
          <v-btn text small class="no-text-transform body-2"
            :color="transportColor(item.transport)"
            @click="$emit('search', item.transport)"
          >{{ item.transport }}</v-btn>
        </template>

        <template v-slot:item.subscription="{ item }">
          {{ ruService(item.subscription) }}
        </template>

        <template v-slot:item.status="{ item }">
           <i class="error--text" v-if="item.meta.err">{{ item.meta.err }}</i>
          <span v-else>{{ item.status }}</span>
        </template>

        <template v-slot:item.content="{ item }">
          <v-tooltip left max-width="640">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" @click="() => { message=item; dialogMessage=true }" style="min-height: 26px !important">
                <v-list-item-subtitle class="caption" style="max-width: 60ch !important">
                  <span>{{ item.content }}</span>
                </v-list-item-subtitle>
              </v-list-item>
            </template>
            <span>
              <b>Заголовок:</b>
              {{ item.title }}<br/><br/>
              <b>Текст:</b>
              <pre>{{ item.content }}</pre>
            </span>
          </v-tooltip>
        </template>

        <template v-slot:item.meta="{ item }">
          <v-btn v-if="item.meta.tid"
            text small class="no-text-transform body-2" color="primary"
            @click="$emit('totransfers', item.meta.tid)"
          >
            {{ item.meta.tid }}
          </v-btn>
        </template>

      </v-data-table>
    </v-flex>
    <v-dialog
      v-model="dialogMessage"
      scrollable
      width="800"
      transition="dialog-transition" v-if="message"
    >
      <v-card>
        <v-card-title class="subtitle-1">
          Сообщение {{ message.messageid }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogMessage=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <span>
            <b>Заголовок:</b>
            {{ message.title }}<br/><br/>
            <b>Текст:</b>
            <pre>{{ message.content }}</pre>
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
            @click="dialogMessage=false"
          >Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ListMessges',
  props: [ 'messages', 'sort-by', 'search' ],
  data: () => ({
    headers: [
      { text: 'id', value: 'messageid', },
      { text: 'транспорт', value: 'transport', },
      { text: 'адрес', value: 'address', },
      { text: 'подписка', value: 'subscription', },
      { text: 'статус', value: 'status' },
      { text: 'текст', value: 'content', },
      { text: 'дата', value: 'cts', width: '160' },
      { text: 'оплата', value: 'meta', },
    ],
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 15, 100, { text:'Все', value:-1 } ]
    },
    itemsPerPage: 15,
    dialogMessage: false,
    message: null
  }),
  methods: {
    transportColor (t) {
      if (t === 'sms') return 'blue lighten-2'
      if (t === 'email') return 'red lighten-2'
      return 'green lighten-2'
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
    ruService (service) {
      if (service === 'payment') return 'Платежи'
      if (service === 'lowbalance') return 'Баланс'
      if (service === 'pass') return 'Проходы'
      if (service === 'purchase') return 'Покупки'
      if (service === 'news') return 'Новости'
      if (service === 'misc') return 'Другое/Сервисные'
      return service
    },
  }
}
</script>

<style lang="css">
</style>
